import React from 'react';
import { ConfigProvider } from 'antd';
import BWModal from 'components/shared/BWModal/BWModal';
import { getFormPopupContainer } from 'components/shared/BWFormControl/popupHelpers';
import './warrantyPopup.scss';

export default function WarrantyModal({ modalClassName = '', cancelAction, primaryAction, children, ...props }) {
  return <ConfigProvider getPopupContainer={getFormPopupContainer}>
    <BWModal {...props} modalClassName={`bw_warranty_popup ${modalClassName}`}
      cancelAction={cancelAction && { icon: 'fi fi-rr-cross-small', ...cancelAction }}
      primaryAction={primaryAction && { icon: 'fi fi-rr-check', ...primaryAction }}>
      {children}
    </BWModal>
  </ConfigProvider>;
}
